<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório geral de saídas ao paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/relatorios/relatorio-geral-saida-paciente/List'

export default {
    components: { List },
}
</script>
